import React, {useState} from "react";
import {Button, Input, ModalBody, ModalFooter, ModalHeader, Spinner} from "reactstrap";
import {useAppContext} from "../../hooks";
import {postJsonAxiosService} from "../../services/callAxios";
import {toastService} from "../../services/toast.service";

const DialpadModal = (props) => {
    const {user, setUser} = useAppContext();
    const {provider, toggle} = props;
    const [apikey, setApikey] = useState("");
    const [errorApikey, setErrorApikey] = useState(false);
    const [orgurl, setOrgUrl] = useState("");
    const [errorOrgUrl, setErrorOrgUrl] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        if (!apikey) {
            setErrorApikey(true);
            return;
        }
        let newProvider = {
            accessToken: apikey,
            provider: "Dialpad",
            service: "Dialer",
        }
        try {
            setLoading(true);
            let response = await postJsonAxiosService("dialpad/webhook/validate", {provider: newProvider});
            if (response) {
                // Create a new copy of the user object with the updated providers array
                const updatedUser = {
                    ...user,
                    customer: {
                        ...user.customer,
                        providers: [
                            ...(user.customer.providers || []),
                            newProvider
                        ]
                    }
                };
                setUser(updatedUser);
                toastService.info("Dialpad Integrated");
                window.location.reload();
            }
            setLoading(false);
        } catch (e) {
            setLoading(false);
            toastService.error("Error while updating integration");
        }
    };

    return (
        <div style={{padding: 20}}>
            <ModalHeader toggle={props.toggle}
                         style={{fontSize: 24, fontWeight: 600, border: "none"}}>
                <span>Add Dialpad Integration</span>
            </ModalHeader>
            <ModalBody>
                <div>
                    <div className="snippet-desc" style={{fontSize: 14, color: "#202124"}}>
                        <p><b>IMPORTANT NOTE:</b> Confirm with Dialpad Support that Admin Call Recording and Admin Call Recording Export via API are enabled for the org. If not enabled, integration will fail.</p>
                        <label>Api Key</label>
                        <Input style={{fontSize: 14, color: "#202124"}}
                               placeholder="Enter API Key"
                               value={apikey}
                               onChange={(e) => {
                                   setApikey(e.target.value);
                                   setErrorApikey(false);
                               }}
                        />
                        {errorApikey ? (
                            <div className="snippet-desc-error" style={{color: "red"}}>
                                Please enter API Key
                            </div>
                        ) : null}
                    </div>
                    <div>
                    </div>
                </div>

            </ModalBody>
            <ModalFooter style={{border: "none", padding: "0px 0px 10px 30px"}}>
                <Button className={"btn-typography-secondary"} onClick={props.toggle}>
                    Cancel
                </Button>{" "}
                <Button className={"btn-typography-primary"} onClick={handleSubmit} disabled={loading}>
                    {!loading ? "Authorize" : "Authorizing"}
                    {loading && <Spinner size="sm" type="grow" color="light" />}
                </Button>{" "}
            </ModalFooter>
        </div>
    )
};

export default DialpadModal;